import React from "react";
import Login from "./Login";
import { Box, Center, Img, Button, Heading } from "@chakra-ui/react";
import Slider from "react-slick";

let prodArr = [
  "https://cdn.modesens.com/umedia/1707018s?w=400",
  "https://cdn.modesens.com/umedia/1707030s?w=400",
  "https://cdn.modesens.com/umedia/1686127s?w=400",
  "https://cdn.modesens.com/umedia/1707018s?w=400",
  "https://cdn.modesens.com/umedia/1707030s?w=400",
  "https://cdn.modesens.com/umedia/1686127s?w=400",
];

function Signup() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
  };

  return (
    <Box>
      <Box
        borderRadius={"10px"}
        width="70%"
        m={"auto"}
        mt={"100px"}
        backgroundColor="black"
      >
        <Box
          display={"flex"}
          gap="40px"
          flexWrap={"wrap"}
          justifyContent="space-evenly"
        >
          <Center>
            <Box width={"220px"}>
              <Slider {...settings}>
                {prodArr.map((el) => (
                  <Box key={el} width="300px">
                    <Img
                      borderRadius={"10px"}
                      m={"10px"}
                      ml="15px"
                      width="190px"
                      height={"260px"}
                      src={el}
                      alt="banner"
                    />
                  </Box>
                ))}
              </Slider>
            </Box>
          </Center>
          <Center>
            <Box>
              <Box mt={"10px"}>
                <Center>
                  <Box>
                    <Heading textAlign={"center"}
                      color = "#fff"
                      textShadow="0 0 7px #fff,0 0 10px #fff,0 0 21px #fff,0 0 42px #0fa,0 0 82px #0fa, 0 0 92px #0fa, 0 0 102px #0fa,0 0 151px #0fa"
                    >
                      WelCome
                    </Heading>
                  </Box>
                </Center>
                <Center>
                  <Heading fontSize={"16px"} textAlign="center" mt={"20px"} 
                   color = "#fff"
                   textShadow="0 0 7px #fff,0 0 10px #fff,0 0 21px #fff,0 0 42px #0fa,0 0 82px #0fa, 0 0 92px #0fa, 0 0 102px #0fa,0 0 151px #0fa"
                  >
                    Please Sign In
                  </Heading>
                </Center>
              </Box>
              <Center>
                <Button
                  width="100px"
                  mt="20px"
                  mb={"30px"}
                  fontFamily={"sans-serif"}
                  fontWeight="bold"
                  backgroundColor={"white"}
                  transition="all 0.5s ease-in-out"
                  _hover={{ background: "blue", color: "white" }}
                >
                  <Login />
                </Button>
              </Center>
            </Box>
          </Center>
        </Box>
      </Box>
    </Box>
  );
}

export default Signup;
